export var OwlPropertyType;
(function (OwlPropertyType) {
    /**
     * @lc-resource http://www.w3.org/2002/07/owl#DatatypeProperty
     */
    OwlPropertyType["DatatypeProperty"] = "DatatypeProperty";
    /**
     * @lc-resource http://www.w3.org/2002/07/owl#ObjectPropert
     */
    OwlPropertyType["ObjectProperty"] = "ObjectProperty";
})(OwlPropertyType || (OwlPropertyType = {}));
//# sourceMappingURL=lightweight-owl-model.js.map